import styled from 'styled-components';
import { device } from '../breakpoints';
import SvgIcon from '../SvgIcon/SvgIcon';
import { ClearFix } from '../utils.styles';
import { playFontSize, regularOutline } from '../typography/helpers';
import { PlayTextStyles } from '../typography/PlayText/PlayText.styles';
import { regularWhite } from '../design-tokens';

export const A11yLinksList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    ${ClearFix};
    width: 100%;
    clear: both;
    margin-bottom: 20px;

    @media ${device.GteMedium} {
        margin-bottom: 30px;
    }
`;

export const A11yListItem = styled.li`
    float: left;
    margin-right: 10px;
`;

export const A11yLink = styled.a`
    ${PlayTextStyles}
    display: block;
    margin: 1px 1em 3px 1px;
    text-decoration: underline;
    color: ${regularWhite};
    ${playFontSize(1.3)}

    &:focus {
        ${regularOutline()}
    }
`;

export const A11yIcon = styled(SvgIcon)`
    margin-right: 5px;
`;
